import React, { useEffect, useState } from "react";
import "./LoanReports.scss";
import { useSelector, useDispatch } from "react-redux";
import { getCoAAllWatched } from "../../util/API/accounting";
import LoanTable from "../../components/LoanTable/LoanTable";
import {
  setAccountList,
  setAccountListFilter,
} from "../../store/redux/accountingTable";
import CSVImage from "../../images/csv-file.png";
import { CSVLink } from "react-csv";
import NewLoanModal from "../../components/NewLoanModal/NewLoanModal";
import LoanDetails from "../../components/LoanDetails/LoanDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import GearModal from "../../components/GearModal/GearModal";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, styled } from "@mui/material";
import PortfolioPerformanceReport from "./PortfolioPerformanceReport/PortfolioPerformanceReport";
import DelinquencyReport from "./DelinquencyReport/DelinquencyReport";
import RiskQualityReport from "./RiskQualityReport/RiskQualityReport";
import ConcentrationReport from "./ConcentrationReport/ConcentrationReport";
import LoanToValueReport from "./LoanToValueReport/LoanToValueReport";
import MaturityReport from "./MaturityReport/MaturityReport";
import InterestRateRiskReport from "./InterestRateRiskReport/InterestRateRiskReport";
import NonPerformingLoansReport from "./NonPerformingLoansReport/NonPerformingLoansReport";
import RegulatoryComplianceReport from "./RegulatoryComplianceReport/RegulatoryComplianceReport";
import ProvisioningReport from "./ProvisioningReport/ProvisioningReport";
import { commonRunQuery } from "../../util/API/loans";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, format, parseISO } from "date-fns";
import { debounce } from 'lodash';
import moment from "moment";
import InterestRevenueReport from "./InterestRevenueReport/InterestRevenueReport";

//using fake data to loop through
const fakeData = [
  {
    nameOfUser: "Jacob",
    loanType: "Micro Loan",
    amount: "$1000",
    amountDue: "$200",
    dueDate: "3/15/2024",
    scoring: 325,
  },
  {
    nameOfUser: "Morgan",
    loanType: "Micro Loan",
    amount: "$4516",
    amountDue: "$2016",
    dueDate: "10/27/2024",
    scoring: 450,
  },
  {
    nameOfUser: "Jamie",
    loanType: "Micro Loan",
    amount: "$8945",
    amountDue: "$722",
    dueDate: "11/07/2025",
    scoring: 600,
  },
  {
    nameOfUser: "Avery",
    loanType: "Micro Loan",
    amount: "$498",
    amountDue: "$777",
    dueDate: "10/22/2024",
    scoring: 710,
  },
  {
    nameOfUser: "Casey",
    loanType: "Tuition Loan",
    amount: "$9873",
    amountDue: "$227",
    dueDate: "10/08/2025",
    scoring: 380,
  },
  {
    nameOfUser: "Casey",
    loanType: "Tuition Loan",
    amount: "$6883",
    amountDue: "$1815",
    dueDate: "06/15/2025",
    scoring: 420,
  },
  {
    nameOfUser: "Quinn",
    loanType: "Term Loan",
    amount: "$116",
    amountDue: "$1317",
    dueDate: "05/19/2025",
    scoring: 540,
  },
  {
    nameOfUser: "Taylor",
    loanType: "Term Loan",
    amount: "$2557",
    amountDue: "$1773",
    dueDate: "02/20/2025",
    scoring: 685,
  },
  {
    nameOfUser: "Morgan",
    loanType: "Micro Loan",
    amount: "$6234",
    amountDue: "$802",
    dueDate: "03/15/2025",
    scoring: 770,
  },
  {
    nameOfUser: "Taylor",
    loanType: "Tuition Loan",
    amount: "$4343",
    amountDue: "$365",
    dueDate: "06/26/2025",
    scoring: 850,
  },
  {
    nameOfUser: "Skyler",
    loanType: "Micro Loan",
    amount: "$6211",
    amountDue: "$655",
    dueDate: "09/29/2025",
    scoring: 330,
  },
];

const LoanReports = () => {
  const [accountType, setAccountType] = useState("All");
  const [reportType, setReportType] = useState("Portfolio Performance Report");
  const [open, setOpen] = useState(false);
  const [gearModalOpen, setGearModalOpen] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [filteredData, setFilteredData] = useState(fakeData);
  const [reportCounts, setReportCounts] = useState(null);
  const [funnelCounts, setFunnelCounts] = useState(null);
  const [loanIssuedCounts, setLoanIssuedCounts] = useState(null);
  const [goalCompletions, setGoalCompletions] = useState(null);
  const [progressBarPercent, setProgressBarPercent] = useState({
    week:0, 
    month:0,
    year:0
  });
  const [duration, setDuration] = useState(3);
  // const [startDate, setStartDate] = useState();
  // const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState(moment().startOf('month').format('yyyy-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('yyyy-MM-DD'));
  const [isCustomFilter, setIsCustomFilter] = useState(false);
  
  const dispatch = useDispatch();

  const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
    border: "none",
    color: "#6B7280",
    fontFamily: "Nunito",
    fontSize: "14px",
    fontStyle: "normal",
    lineHeight: "33.6px",
    justifyContent: "left",
  }));

  const StyledDatePicker = styled(DatePicker)({
    borderRadius: "5px", 
    background: "white", 
    width: "120%", 
    height: "40px", 
    "& .MuiInputBase-input": {
      padding: "8px 12px", 
      fontSize: "16px", 
      fontFamily: "Nunito", 
      fontWeight: "600", 
      color: "#6B7280",
    },
    "& .MuiInputLabel-outlined": {
      color: "#6B7280", 
      fontSize: "14px", 
      fontFamily: "Nunito", 
      fontWeight: "400", 
      backgroundColor: "white", 
      padding: "0 5px", 
    },
  });
  const MemoizedDatePicker = React.memo((props) => <StyledDatePicker {...props} />);

  const formatDate = (date) => {
    console.log(date)
    if (!date) return ""; 
    let d = date instanceof Date ? date : new Date(`${date}T00:00`);
    console.log(d)
    const year = d.getFullYear();
    const month = d.getMonth() + 1; 
    const day = d.getDate(); 

    console.log(`${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`)
  
    return `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;
  };

  const handleClose = () => setOpen(false);
  const handleOpen = (transaction) => {
    setOpen(true);
  };

  const handleGearModalClose = () => setGearModalOpen(false);
  const handleGearModalOpen = () => {
    setGearModalOpen(true);
  };

  const accountingDataStateFilter = useSelector(
    (state) => state.accountingTable.accountingTableFilter
  );

  useEffect(() => {
    async function fetchgetCoAAllWatched() {
      let accountingData = await getCoAAllWatched("1/UXP");
      dispatch(setAccountList({ accountingData: accountingData.data.record }));
      dispatch(
        setAccountListFilter({ filterAccountData: accountingData.data.record })
      );
      setLoadingData(false);
    }

    fetchgetCoAAllWatched();
  }, []);

  useEffect(() => {
    getReportCounts();
  }, []);

  useEffect(()=> {
    calculatePercentages();
  }, [goalCompletions]);

  const calculatePercentages = async() => {
    const weekDue = parseFloat(goalCompletions?.current_week_payment_due);
    const weekPaid = parseFloat(goalCompletions?.current_week_paid_amount);
    const monthDue = parseFloat(goalCompletions?.current_month_payment_due);
    const monthPaid = parseFloat(goalCompletions?.current_month_paid_amount);
    const yearDue = parseFloat(goalCompletions?.current_year_payment_due);
    const yearPaid = parseFloat(goalCompletions?.current_year_paid_amount);

    // Calculate percentages
    const weekPaidPercentage = weekDue ? ((weekPaid / weekDue) * 100).toFixed(2) : "0.00";
    const monthPaidPercentage = monthDue ? ((monthPaid / monthDue) * 100).toFixed(2) : "0.00";
    const yearPaidPercentage = yearDue ? ((yearPaid / yearDue) * 100).toFixed(2) : "0.00";

    setProgressBarPercent({
      week: parseFloat(weekPaidPercentage),
      month: parseFloat(monthPaidPercentage),
      year: parseFloat(yearPaidPercentage),
    });

    console.log("Week Paid %:", weekPaidPercentage);
    console.log("Month Paid %:", monthPaidPercentage);
    
  }

  const getReportCounts = async() => {
    try {
      const response = await commonRunQuery(249, "");
      const goalCompletionResponse = await commonRunQuery(250, "");
      const response2 = await commonRunQuery(353, "");
      const loanIssuedResponse = await commonRunQuery(354, "");
      console.log("goalCompletionResponse=========------------------",goalCompletionResponse?.data?.body?.record);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        setReportCounts(response?.data?.body?.record);     
      }
      if ( goalCompletionResponse?.data?.header?.callStatus === "1" && goalCompletionResponse?.data?.header?.reccount !== "0" ) {
        setGoalCompletions(goalCompletionResponse?.data?.body?.record);     
      }
      if ( response2?.data?.header?.callStatus === "1" && response2?.data?.header?.reccount !== "0" ) {
        setFunnelCounts(response2?.data?.body?.record);     
      }
      if ( loanIssuedResponse?.data?.header?.callStatus === "1" && loanIssuedResponse?.data?.header?.reccount !== "0" ) {
        setLoanIssuedCounts(loanIssuedResponse?.data?.body?.record);     
      }
    } catch (error) {
      
    }
  }

  const titleRow = [`Charts of Accounts`];

  const csvData = [
    titleRow,
    [],
    ["Account Type", "Account ID", "Account Name", "Debit", "Credit"],
    ...(accountingDataStateFilter && Array.isArray(accountingDataStateFilter)
      ? accountingDataStateFilter.map((row) => [
          row.vacctstructure.accttypename,
          row.vacctstructure.acctID,
          row.vacctstructure.firstName + " " + row.vacctstructure.lastName,
          parseInt(row.vacctstructure.balance) > 0
            ? row.vacctstructure.balance
            : "-",
          parseInt(row.vacctstructure.balance) < 0
            ? Math.abs(parseInt(row.vacctstructure.balance) * -1)
            : "-",
        ])
      : []),
  ];

  const handleAccountType = (e) => {
    let value = e.target.value;
    setAccountType(value);
    let filteredAccountTypes = fakeData.filter((data) => {
      return data.loanType === value;
    });
    setFilteredData(value === "All" ? fakeData : filteredAccountTypes);
  };

  const loanAmount = [
    200, 4516, 8945, 498, 9873, 6883, 116, 2557, 6234, 4343, 6211,
  ].reduce((partialSum, a) => partialSum + a, 0);
  const amountDue = [
    200, 2016, 722, 777, 227, 1815, 1317, 1773, 802, 365, 655,
  ].reduce((partialSum, a) => partialSum + a, 0);

  const handleStartDateChange = debounce((value) => {
    if (!value) return;
  
    const newStartDate = parseISO(value);
    const currentEndDate = endDate ? parseISO(endDate) : null;
  
    // If endDate is not set, make it same as start
    if (!currentEndDate) {
      setEndDate(formatDate(newStartDate));
    }
    // If date gap is more than 1 month, adjust endDate
    // else if (currentEndDate.getTime() - newStartDate.getTime() > 31 * 24 * 60 * 60 * 1000) {
    //   const maxEnd = new Date(newStartDate);
    //   maxEnd.setMonth(maxEnd.getMonth() + 1);
    //   setEndDate(formatDate(maxEnd));
    // }
  
    setStartDate(formatDate(newStartDate));
  }, 300);

  const handleEndDateChange = debounce((value) => {
    if (!value) return;
  
    const newEndDate = parseISO(value);
    const currentStartDate = startDate ? parseISO(startDate) : null;
  
    // If startDate is not set, make it same as end
    if (!currentStartDate) {
      setStartDate(formatDate(newEndDate));
    }
    // If date gap is more than 1 month, adjust startDate
    // else if (newEndDate.getTime() - currentStartDate.getTime() > 31 * 24 * 60 * 60 * 1000) {
    //   const minStart = new Date(newEndDate);
    //   minStart.setMonth(minStart.getMonth() - 1);
    //   setStartDate(formatDate(minStart));
    // }
  
    setEndDate(formatDate(newEndDate));
  }, 300);

  const handleGetReports = () => {
    setIsCustomFilter(!isCustomFilter);
    console.log("startDate-----------",startDate)
    console.log("endDate-----------",endDate)
  }

  const handleSelectChange = async(e) => {
    const value = e.target.value;

    setDuration(e.target.value);
    
    const today = new Date();

    if (value === "1") {
      // Today
      const formattedToday = formatDate(today);
      setStartDate(formattedToday);
      setEndDate(formattedToday);
    } else if (value === "2") {
      // Current week
      const weekStart = startOfWeek(today, { weekStartsOn: 1 }); // Monday as the first day
      const weekEnd = endOfWeek(today, { weekStartsOn: 1 });
      setStartDate(formatDate(weekStart));
      setEndDate(formatDate(weekEnd));
    } else if (value === "3") {
      // Current month
      const monthStart = startOfMonth(today);
      const monthEnd = endOfMonth(today);
      setStartDate(formatDate(monthStart));
      setEndDate(formatDate(monthEnd));
    }

    console.log("e-----------",e.target.value)
    console.log("startDate-----------",startDate)
    console.log("endDate-----------",endDate)
  }

  return (
    <>
      <NewLoanModal open={open} handleClose={handleClose} />
      <GearModal open={gearModalOpen} handleClose={handleGearModalClose} />
      <div className="page-container loan-container">
        <div className="header-container">
          <div className="page-title">Loan Reports</div>
        </div>

        <LoanDetails reportCounts={reportCounts} progressBarPercent={progressBarPercent} goalCompletions={goalCompletions} funnelCounts={funnelCounts} loanIssuedCounts={loanIssuedCounts} />

        <div className="transaction-history">
          <div className="d-flex justify-content-between">
            <p className="transaction-history-title">Loan Reports</p>
            {/* <p className="transaction-history-subtitle">
              Loan Book Value: ${loanAmount.toLocaleString()}
            </p>
            <p className="transaction-history-subtitle">
              Repayments this Month: ${amountDue.toLocaleString()}
            </p> */}
            <div className="d-flex gap-5 align-items-center">
              {/* <div>
                <CSVLink data={csvData} filename={`Chart-Of-Accounts.csv`}>
                  <img src={CSVImage} className="excel-icon" loading="lazy" />
                </CSVLink>
              </div> */}
              {/* <div className="post-entry-button" onClick={handleOpen}>
                New Loan
              </div> */}
              {/* <FontAwesomeIcon
                icon={faGear}
                className="gear-icon"
                onClick={handleGearModalOpen}
              /> */}
            </div>
          </div>
          <div className="transaction-option-container mt-3">
            <Box className="transaction-filter-container" width={"100%"}>
              <Box className="filter-left" width={"100%"}>
                <Box width={"100%"} sx={{ display: "flex", justifyContent:"space-between" }}>
                  <Box sx={{ display: "flex", gap:1 }} >
                    <Box>
                      {/* <Box>
                        <label htmlFor="time" className="selector-titles">
                          Select Report
                        </label>
                      </Box> */}
                      <Box className="transaction-selector">
                        <select onChange={(e)=>  {
                          setReportType(e.target.value);
                          setDuration('3');
                          setStartDate(moment().startOf('month').format('yyyy-MM-DD'))
                          setEndDate(moment().endOf('month').format('yyyy-MM-DD'))
                        }} value={reportType}>
                          <option value="Portfolio Performance Report">
                            Portfolio Performance Report
                          </option>
                          <option value="Delinquency Report">
                            Delinquency Report
                          </option>
                          <option value="Risk Grade/Credit Quality Report">
                            {/* Risk Grade/Credit Quality Report */} Open Loans
                          </option>
                          <option value="Concentration Report">
                            Concentration Report
                          </option>
                          <option value="Loan to Value (LTV) Report">
                            Loan to Value (LTV) Report
                          </option>
                          <option value="Maturity Report">Maturity Report</option>
                          <option value="Interest Rate Risk Report">
                            Interest Rate Risk Report
                          </option>
                          <option value="Non-Performing Loans (NPL) Report">
                            Non-Performing Loans (NPL) Report
                          </option>
                          <option value="Provisioning Report">
                            Provisioning Report
                          </option>
                          <option value="Regulatory Compliance Report">
                            Regulatory Compliance Report
                          </option>
                          <option value="Interest Revenue Report">
                            Interest Revenue Report
                          </option>
                          
                        </select>
                      </Box>
                    </Box>

                    <Box sx={{ display:"flex", marginRight: "auto"}}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="select-view-label"
                          sx={{
                            color: "#6B7280",
                            fontFamily: "Nunito",
                            fontSize: "16px",
                            background: "white",
                            padding: "0 5px",
                          }}
                        >
                          Select View
                        </InputLabel>
                        <Select
                          labelId="select-view-label"
                          name="selectView"
                          className="reporting-select"
                          onChange={handleSelectChange}
                          value={duration}
                          sx={{
                            borderRadius: "5px", // Custom border radius
                            border: "1px solid #D7D7D7", // Your custom border
                            color: "#6B7280", // Text color
                            fontFamily: "Nunito", // Font family
                            fontSize: "16px", // Font size
                            padding: "0px 10px", // Adjust padding
                            width: "100%", // Width
                            height: "40px", // Height
                            background: "white", // Background color
                            textAlign: "left", // Align text to the left
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none", // Removes the default border applied by Material-UI
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              border: "none", // Ensures no border appears on hover
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              border: "none", // Ensures no border appears on focus
                            },
                          }}
                        >
                          <CustomMenuItem value="" disabled>
                            Reports
                          </CustomMenuItem>
                          <CustomMenuItem value="1">Report Daily</CustomMenuItem>
                          <CustomMenuItem value="2">Report Weekly</CustomMenuItem>
                          <CustomMenuItem value="3">Report Monthly</CustomMenuItem>
                          <CustomMenuItem value="4">Report Custom</CustomMenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", gap:2, alignItems:"center" }}>
                    {/* From Date */}
                    <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <MemoizedDatePicker
                          label="From"
                          disabled={duration !== "4"}
                          value={parseISO(startDate) || null} 
                          onChange={(newDate) => {
                            if (newDate && !isNaN(newDate)) {
                              handleStartDateChange(format(newDate, "yyyy-MM-dd"))
                            }
                          }}
                          inputFormat="yyyy-MM-dd" 
                          InputLabelProps={{ shrink: true }}
                          shouldDisableDate={(date) => {
                            const parsedEnd = endDate ? parseISO(endDate) : null;
                            return parsedEnd ? date > parsedEnd : false;
                          }}
                        />
                      </LocalizationProvider>
                    </Box>

                    {/* To Date */}
                    <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <MemoizedDatePicker
                          label="To"
                          disabled={duration !== "4"}
                          value={parseISO(endDate) || null} 
                          onChange={(newDate) => {
                            if (newDate && !isNaN(newDate)) {
                              handleEndDateChange(format(newDate, "yyyy-MM-dd"))
                            }
                          }}
                          inputFormat="yyyy-MM-dd"
                          InputLabelProps={{ shrink: true }}
                          shouldDisableDate={(date) => {
                            const parsedStart = startDate ? parseISO(startDate) : null;
                            return parsedStart ? date < parsedStart : false;
                          }}
                        />
                      </LocalizationProvider>
                    </Box>

                    <Box>
                      <Button
                        variant="outlined"
                        sx={{
                          textTransform: "none",
                          fontSize: "14px",
                          color: "#6B7280",
                          borderColor: "#D7D7D7",
                          borderRadius: "5px",
                          // padding: "5px 15px",
                          height: "40px",
                          "&:hover": {
                            backgroundColor: "#F5F5F5",
                            borderColor: "#D7D7D7",
                          },
                        }}
                        disabled={duration !== "4"}
                        onClick={handleGetReports}
                      >
                        Get Reports
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </div>
          <div>
            {loadingData ? (
              <>Loading...</>
            ) : (
                <Box>
                    {
                        reportType === "Portfolio Performance Report" ?
                        <PortfolioPerformanceReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Delinquency Report" ?
                        <DelinquencyReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Risk Grade/Credit Quality Report" ?
                        <RiskQualityReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Concentration Report" ?
                        <ConcentrationReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Loan to Value (LTV) Report" ?
                        <LoanToValueReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Maturity Report" ?
                        <MaturityReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Interest Rate Risk Report" ?
                        <InterestRateRiskReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Non-Performing Loans (NPL) Report" ?
                        <NonPerformingLoansReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Provisioning Report" ?
                        <ProvisioningReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Interest Revenue Report" ?
                        <InterestRevenueReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        reportType === "Regulatory Compliance Report" ?
                        <RegulatoryComplianceReport startDate={startDate} endDate={endDate} duration={duration} isCustomFilter={isCustomFilter} /> :
                        <LoanTable fakeData={filteredData} />
                    }
                    {/* <LoanTable fakeData={filteredData} /> */}
                </Box>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanReports;























// import { Box, Typography, Select, MenuItem, styled, Button, InputLabel, FormControl, Grid, Tab, Tabs, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Link } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import "./LoanReports.scss";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { format, parseISO } from "date-fns";
// import { debounce } from 'lodash';

// const LoanReports = () => {
//     const [activeTab, setActiveTab] = useState(0);
//     const [statusFilter, setStatusFilter] = useState('All'); // 'Issued' or 'Pending'
//     const [termFilter, setTermFilter] = useState('All');
//     const [duration, setDuration] = useState(1);
//     const [startDate, setStartDate] = useState();
//     const [endDate, setEndDate] = useState();

//     const termOptions = ["No Term", "Daily", "Weekly", "Bi-Weekly", "Monthly", "Yearly"];
//     const statusArray = [{key:"Issued", label:"Issued"}, {key:"Pending", label:"Pending"}, {key:"Cancelled", label:"Cancelled"}];

//     const StyledDatePicker = styled(DatePicker)({
//         borderRadius: "5px", 
//         background: "white", 
//         width: "120%", 
//         height: "40px", 
//         "& .MuiInputBase-input": {
//           padding: "8px 12px", 
//           fontSize: "16px", 
//           fontFamily: "Nunito", 
//           fontWeight: "600", 
//           color: "#6B7280",
//         },
//         "& .MuiInputLabel-outlined": {
//           color: "#6B7280", 
//           fontSize: "14px", 
//           fontFamily: "Nunito", 
//           fontWeight: "400", 
//           backgroundColor: "white", 
//           padding: "0 5px", 
//         },
//     });

//     const MemoizedDatePicker = React.memo((props) => <StyledDatePicker {...props} />);

//     const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
//         border: "none",
//         color: "#6B7280",
//         fontFamily: "Nunito",
//         fontSize: "14px",
//         fontStyle: "normal",
//         lineHeight: "33.6px",
//         justifyContent: "left",
//     }));

//     const StyledInputLabel = styled(InputLabel)({
//         color: "#6B7280",
//         fontFamily: "Nunito",
//         fontSize: "16px",
//         background: "white",
//         padding: "0 5px",
//         lineHeight: "1.2",
//         top: "-4px", 
//         "&.Mui-focused": {
//           color: "#145388",
//         },
//         "&.MuiInputLabel-shrink": {
//           top: "2px"
//         },
//     });

//     const StyledSelect = styled(Select)({
//         borderRadius: "5px", 
//         border: "1px solid #D7D7D7", 
//         color: "#6B7280",
//         fontFamily: "Nunito",
//         fontSize: "16px",
//         padding: "0px 10px",
//         width: "200px",
//         height: "40px",
//         background: "white", 
//         textAlign: "left", 
//         "& .MuiOutlinedInput-notchedOutline": { border: "none" },
//         "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
//         "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
//     });

//     const handleTabChange = (event, newValue) => {
//         setActiveTab(newValue);
//     };

//     const formatDate = (date) => {
//         console.log(date)
//         if (!date) return ""; 
//         let d = date instanceof Date ? date : new Date(`${date}T00:00`);
//         console.log(d)
//         const year = d.getFullYear();
//         const month = d.getMonth() + 1; 
//         const day = d.getDate(); 
    
//         console.log(`${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`)
      
//         return `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;
//     };

//     const handleStartDateChange = debounce((value) => {
//         if (!value) return;
//         const newStartDate = new Date(value);
//         const maxEndDate = new Date(newStartDate);
//         maxEndDate.setMonth(maxEndDate.getMonth() + 1); 
      
//         setEndDate(formatDate(maxEndDate));
      
//         setStartDate(value);
//     }, 1000);
      
//       const handleEndDateChange = debounce((value) => {
//         if (!value) return;
//         const newEndDate = new Date(value);
//         const minStartDate = new Date(newEndDate);
//         minStartDate.setMonth(minStartDate.getMonth() - 1); 
      
//         setStartDate(formatDate(minStartDate));
    
//         setEndDate(value);
//     }, 1000);

//     return (
//         <>
//             <Box className="page-container loan-container">
//                 <Box className="header-container">
//                     <Box className="page-title">
//                         Loan Reports
//                     </Box>
//                 </Box>

//                 <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 2 }}>
//                     <Tabs value={activeTab} onChange={handleTabChange}>
//                         <Tab label="Loan Status" />
//                         <Tab label="Loans Due" />
//                         <Tab label="Age Analysis" />
//                     </Tabs>
//                 </Box>

//                 <Box className="tab-content">
//                     {activeTab === 0 && (
//                         <Box className="batch-tabs">
//                             <Box sx={{ backgroundColor: "#FFFFFF", padding: "10px", borderRadius: "8px" }}>
//                                 <Grid container spacing={2} alignItems="center">
//                                     <Grid item xs={2} xl={1.5} sx={{ display: "flex", alignItems: "center" }}>
//                                         <FormControl fullWidth>
//                                             <StyledInputLabel
//                                                 id="user-label"
//                                                 sx={{
//                                                     color: "#6B7280",
//                                                     fontFamily: "Nunito",
//                                                     fontSize: "16px",
//                                                     background: "white",
//                                                     padding: "0 5px",
//                                                     lineHeight: "1.2", 
//                                                     top: "-4px", 
//                                                     "&.Mui-focused": { color: "#145388" },
//                                                     "&.MuiInputLabel-shrink": { top: "2px" },
//                                                 }}
//                                             >
//                                                 Status
//                                             </StyledInputLabel>
//                                             <StyledSelect
//                                                 labelId="user-label"
//                                                 name="user"
//                                                 className="reporting-select"
//                                                 onChange={(e) => {
//                                                     setStatusFilter(e.target.value)
//                                                 }}
//                                                 value={statusFilter}
//                                                 fullWidth
//                                             >
//                                             <CustomMenuItem value="All">
//                                                 All
//                                             </CustomMenuItem>
//                                             {statusArray.map((option, idx) => (
//                                                 <CustomMenuItem key={idx} value={option.key}>
//                                                     {option.label}
//                                                 </CustomMenuItem>
//                                             ))}
//                                             </StyledSelect>
//                                         </FormControl>
//                                     </Grid>

//                                     <Grid item xs={2} xl={1.5} sx={{ display: "flex", alignItems: "center" }}>
//                                         <FormControl fullWidth>
//                                             <StyledInputLabel
//                                                 id="user-label"
//                                                 sx={{
//                                                     color: "#6B7280",
//                                                     fontFamily: "Nunito",
//                                                     fontSize: "16px",
//                                                     background: "white",
//                                                     padding: "0 5px",
//                                                     lineHeight: "1.2", 
//                                                     top: "-4px", 
//                                                     "&.Mui-focused": { color: "#145388" },
//                                                     "&.MuiInputLabel-shrink": { top: "2px" },
//                                                 }}
//                                             >
//                                                 Term Type
//                                             </StyledInputLabel>
//                                             <StyledSelect
//                                                 labelId="user-label"
//                                                 name="user"
//                                                 className="reporting-select"
//                                                 onChange={(e) => {
//                                                     setTermFilter(e.target.value)
//                                                 }}
//                                                 value={termFilter}
//                                                 fullWidth
//                                             >
//                                             <CustomMenuItem value="All">
//                                                 All
//                                             </CustomMenuItem>
//                                             {termOptions.map((term, index) => (
//                                                 <CustomMenuItem key={index} value={term}>
//                                                     {term}
//                                                 </CustomMenuItem>
//                                             ))}
//                                             </StyledSelect>
//                                         </FormControl>
//                                     </Grid>

//                                     <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
//                                         <LocalizationProvider dateAdapter={AdapterDateFns}>
//                                         <MemoizedDatePicker
//                                             label="From"
//                                             // disabled={duration !== "4"}
//                                             value={parseISO(startDate) || null} 
//                                             onChange={(newDate) => {
//                                                 if (newDate && !isNaN(newDate)) {
//                                                     handleStartDateChange(format(newDate, "yyyy-MM-dd"))
//                                                 }
//                                             }}
//                                             inputFormat="yyyy-MM-dd" 
//                                             InputLabelProps={{ shrink: true }}
//                                         />
//                                         </LocalizationProvider>
//                                     </Grid>

//                                     <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
//                                         <LocalizationProvider dateAdapter={AdapterDateFns}>
//                                         <MemoizedDatePicker
//                                             label="To"
//                                             // disabled={duration !== "4"}
//                                             value={parseISO(endDate) || null} 
//                                             onChange={(newDate) => {
//                                             if (newDate && !isNaN(newDate)) {
//                                                 handleEndDateChange(format(newDate, "yyyy-MM-dd"))
//                                             }
//                                             }}
//                                             inputFormat="yyyy-MM-dd"
//                                             InputLabelProps={{ shrink: true }}
//                                         />
//                                         </LocalizationProvider>
//                                     </Grid>

//                                     <Grid item xs={2} xl={3} sx={{ display: "flex", alignItems: "center" }}>
//                                         <Button
//                                         variant="outlined"
//                                         sx={{
//                                             textTransform: "none",
//                                             fontSize: "14px",
//                                             color: "#6B7280",
//                                             borderColor: "#D7D7D7",
//                                             borderRadius: "5px",
//                                             padding: "5px 15px",
//                                             height: "40px",
//                                             "&:hover": {
//                                             backgroundColor: "#F5F5F5",
//                                             borderColor: "#D7D7D7",
//                                             },
//                                         }}
//                                         // onClick={clearFilter}
//                                         >
//                                             Get Reports
//                                         </Button>
//                                     </Grid>
//                                 </Grid>

//                                 <Box className="mt-4">
//                                     <TableContainer
//                                         component={Paper}
//                                         sx={{ boxShadow: "none", overflowX: "auto" }}
//                                     >
//                                         <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
//                                             <TableHead>
//                                                 <TableRow>
//                                                     <TableCell style={{ width: 100 }} className="batch-table-headers">
//                                                         Report Id
//                                                     </TableCell>
//                                                     <TableCell
//                                                         align="left"
//                                                         style={{ width: 180 }}
//                                                         className="batch-table-headers"
//                                                     >
//                                                         Request Date
//                                                     </TableCell>
//                                                     <TableCell
//                                                         align="left"
//                                                         style={{ width: 300 }}
//                                                         className="batch-table-headers"
//                                                     >
//                                                         Input File
//                                                     </TableCell>
//                                                     <TableCell
//                                                         align="left"
//                                                         style={{ width: 160 }}
//                                                         className="batch-table-headers"
//                                                     >
//                                                         Status
//                                                     </TableCell>
//                                                     <TableCell
//                                                         align="left"
//                                                         style={{ width: 180 }}
//                                                         className="batch-table-headers"
//                                                     >
//                                                         Scheduled Date
//                                                     </TableCell>
//                                                     <TableCell
//                                                         align="left"
//                                                         style={{ width: 160 }}
//                                                         className="batch-table-headers"
//                                                     >
//                                                         Comments
//                                                     </TableCell>
//                                                     <TableCell
//                                                         align="left"
//                                                         style={{ width: 160 }}
//                                                         className="batch-table-headers"
//                                                     >
//                                                         Download
//                                                     </TableCell>
//                                                     <TableCell
//                                                         align="left"
//                                                         style={{ width: 120 }}
//                                                         className="batch-table-headers"
//                                                     >
//                                                         Action
//                                                     </TableCell>
//                                                 </TableRow>
//                                             </TableHead>

//                                             <TableBody>
//                                                 <TableRow>
//                                                     <TableCell
//                                                         component="th"
//                                                         scope="row"
//                                                         style={{ width: 100 }}
//                                                         className="batch-row-text"
//                                                     >
//                                                         111
//                                                     </TableCell>
//                                                     <TableCell
//                                                         component="th"
//                                                         scope="row"
//                                                         style={{ width: 180 }}
//                                                         className="batch-row-text"
//                                                     >
//                                                         111
//                                                     </TableCell>
//                                                     <TableCell
//                                                         component="th"
//                                                         scope="row"
//                                                         style={{ width: 300 }}
//                                                         className="batch-row-text"
//                                                     >
//                                                         111
//                                                     </TableCell>
//                                                     <TableCell
//                                                         component="th"
//                                                         scope="row"
//                                                         style={{ width: 160 }}
//                                                         className="batch-row-text"
//                                                     >
//                                                         111
//                                                     </TableCell>
//                                                     <TableCell
//                                                         component="th"
//                                                         scope="row"
//                                                         style={{ width: 180 }}
//                                                         className="batch-row-text"
//                                                     >
//                                                         111
//                                                     </TableCell>
//                                                     <TableCell
//                                                         component="th"
//                                                         scope="row"
//                                                         style={{ width: 160 }}
//                                                         className="batch-row-text"
//                                                     >
//                                                         111
//                                                     </TableCell>
//                                                     <TableCell
//                                                         component="th"
//                                                         scope="row"
//                                                         style={{ width: 160 }}
//                                                         className="batch-row-text"
//                                                     >
//                                                         <Link>Download File</Link>
//                                                     </TableCell>
//                                                     <TableCell
//                                                         component="th"
//                                                         scope="row"
//                                                         style={{ width: 120 }}
//                                                         className="batch-row-text"
//                                                     >
//                                                         111
//                                                     </TableCell>
                                                    
//                                                 </TableRow>
//                                             </TableBody>
//                                         </Table>
//                                     </TableContainer>
//                                 </Box>
//                             </Box>
//                         </Box>
//                     )}
//                     {activeTab === 1 && (
//                         <Box>
//                             <h3>Loans Due</h3>
//                         </Box>
//                     )}
//                     {activeTab === 2 && (
//                         <Box>
//                             <h3>Age Analysis</h3>
//                         </Box>
//                     )}
//                 </Box>
//             </Box>
//         </>
//     )
// }

// export default LoanReports;